(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.shopify-section-header');
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
this.header.classList.add('always-fixed');
};

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (!this.preventReveal) {
	requestAnimationFrame(this.reveal.bind(this));
	}else {
	window.clearTimeout(this.isScrolling);

	this.isScrolling = setTimeout(() => {
	this.preventReveal = false;
	}, 66);

	requestAnimationFrame(this.hide.bind(this));
	}
	} else if (scrollTop <= this.headerBounds.top) {
	requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
	this.closeMenuDisclosure();
	}

	reveal() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
		}

		}

		customElements.define('sticky-header', StickyHeader);

		
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.isProductPage = true;
    }

    hide() {
      super.hide(this.isProductPage);
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);

  // Mobile media slider indicator (stacked gallery mode): one dash per
  // VISIBLE media item. Rubik Variant Images swaps item visibility at
  // runtime, so a MutationObserver rebuilds the dashes when the set of
  // visible items actually changes (signature check — stray mutations such
  // as lazyload class swaps must not reset the scroll position).
  (function () {
    const MOBILE = window.matchMedia('(max-width: 749px)');

    const initMediaDashes = (wrapper) => {
      const list = wrapper.querySelector('.product__media-list__container--large');
      const dashes = wrapper.querySelector('[data-product-media-dashes]');
      if (!list || !dashes) return;
      let items = [];
      let lastSignature = null;

      const visibleItems = () =>
        Array.prototype.filter.call(
          list.querySelectorAll('.product__media-item'),
          (item) => getComputedStyle(item).display !== 'none'
        );

      const setActive = (index) => {
        Array.prototype.forEach.call(dashes.children, (dash, i) => {
          dash.classList.toggle('is-active', i === index);
        });
      };

      // The active dash follows the nearest snap position — plain scroll
      // math instead of an IntersectionObserver (deterministic, and IO does
      // not fire in some embedded/hidden contexts).
      const syncActive = () => {
        if (!items.length) return;
        let best = 0;
        let bestDistance = Infinity;
        items.forEach((item, i) => {
          const distance = Math.abs(item.offsetLeft - list.scrollLeft);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        });
        setActive(best);
      };

      const rebuild = () => {
        items = visibleItems();
        const signature =
          (MOBILE.matches ? 'm|' : 'd|') +
          items.map((item) => item.getAttribute('data-media-id') || '').join('|');
        if (signature === lastSignature) return;
        lastSignature = signature;

        dashes.textContent = '';
        dashes.hidden = !MOBILE.matches || items.length < 2;
        if (dashes.hidden) return;

        items.forEach(() => dashes.appendChild(document.createElement('span')));
        list.scrollTo({ left: 0 }); // a new variant set starts on its first image
        setActive(0);
      };

      let rebuildTimer = null;
      const queueRebuild = () => {
        window.clearTimeout(rebuildTimer);
        rebuildTimer = window.setTimeout(rebuild, 100);
      };
      let scrollTimer = null;
      list.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(syncActive, 80);
        },
        { passive: true }
      );

      rebuild();
      new MutationObserver(queueRebuild).observe(list, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden'],
      });
      if (MOBILE.addEventListener) MOBILE.addEventListener('change', queueRebuild);
      else MOBILE.addListener(queueRebuild);
    };

    const startMediaDashes = () => {
      document.querySelectorAll('.product__media-wrapper-stacked').forEach(initMediaDashes);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startMediaDashes);
    } else {
      startMediaDashes();
    }
  })();

  // Custom field blocks: enable native constraint validation on the product
  // form(s) the fields post to, and mask/validate time fields (data-pf-time
  // "ms" = 00:00, "hms" = 00:00:00). Same UX as the previous inline
  // snippets: colons are inserted while typing, an empty value never errors
  // mid-typing, blur validates without reportValidity. Stricter than
  // before: every segment except the first must be <= 59.
  (function () {
    const initProductFields = () => {
      const fieldInputs = document.querySelectorAll('.pf-field [form]');
      if (!fieldInputs.length) return;

      // Remove novalidate from exactly the forms these fields belong to —
      // never from unrelated forms elsewhere on the page.
      const forms = new Set();
      fieldInputs.forEach((el) => {
        const form = document.getElementById(el.getAttribute('form'));
        if (form) forms.add(form);
      });
      forms.forEach((form) => form.removeAttribute('novalidate'));

      document.querySelectorAll('[data-pf-time]').forEach((input) => {
        const isHms = input.dataset.pfTime === 'hms';
        const maxDigits = isHms ? 6 : 4;
        const formatMessage =
          input.dataset.pfMsgFormat ||
          (isHms ? 'Please use the format 00:00:00' : 'Please use the format 00:00');
        const rangeMessage =
          input.dataset.pfMsgRange ||
          (isHms ? 'Minutes and seconds must be 59 or less' : 'Seconds must be 59 or less');
        const fullLength = isHms ? 8 : 5;
        const pattern = isHms ? /^\d{2}:\d{2}:\d{2}$/ : /^\d{2}:\d{2}$/;

        const format = (value) => {
          const digits = value.replace(/\D/g, '').slice(0, maxDigits);
          if (isHms && digits.length >= 5) {
            return digits.slice(0, 2) + ':' + digits.slice(2, 4) + ':' + digits.slice(4);
          }
          if (digits.length >= 3) {
            return digits.slice(0, 2) + ':' + digits.slice(2);
          }
          return digits;
        };

        // '' = valid; otherwise the message to show. Every segment except
        // the first (hours for hms, minutes for pace) must be <= 59.
        const problem = (value) => {
          if (!pattern.test(value)) return formatMessage;
          const tail = value.split(':').slice(1);
          for (let i = 0; i < tail.length; i++) {
            if (parseInt(tail[i], 10) > 59) return rangeMessage;
          }
          return '';
        };

        const validate = (value, onlyWhenComplete) => {
          if (value === '' || (onlyWhenComplete && value.length < fullLength)) {
            input.setCustomValidity('');
            return;
          }
          input.setCustomValidity(problem(value));
        };

        input.addEventListener('input', (event) => {
          event.target.value = format(event.target.value);
          validate(event.target.value.trim(), true);
        });

        input.addEventListener('blur', (event) => {
          validate(event.target.value.trim(), false);
          // no reportValidity() — leaving the field must never trap focus
        });

        input.addEventListener('paste', (event) => {
          event.preventDefault();
          const pasted = (event.clipboardData || window.clipboardData).getData('text');
          input.value = format(pasted);
          validate(input.value.trim(), false);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductFields);
    } else {
      initProductFields();
    }
  })();

  // Description read-more (round 75): the short plain-text excerpt swaps
  // for the full rich description; the toggle flips label + aria state.
  (function () {
    const initReadMore = () => {
      document.querySelectorAll('[data-pd-readmore]').forEach((box) => {
        const shortEl = box.querySelector('[data-pd-desc-short]');
        const fullEl = box.querySelector('[data-pd-desc-full]');
        const toggle = box.querySelector('[data-pd-desc-toggle]');
        if (!shortEl || !fullEl || !toggle) return;
        toggle.addEventListener('click', () => {
          const expand = fullEl.hidden;
          fullEl.hidden = !expand;
          shortEl.hidden = expand;
          toggle.setAttribute('aria-expanded', expand ? 'true' : 'false');
          toggle.textContent = expand
            ? toggle.getAttribute('data-less') || 'Read less'
            : toggle.getAttribute('data-more') || 'Read more';
        });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initReadMore);
    } else {
      initReadMore();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
